import React, { useState } from "react";
import {
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
  TextField,
  Paper,
} from "@mui/material";

import InboxTab from "./tabs/InboxTab"; // ✅ Reuse your existing InboxTab
import classsoftLogo from '../assets/classsoft.png';

// --- Utility function to parse username like in PassbookPage ---
function parseUsername(username) {
  const parts = username.split("-");
  const companyCode = parts[0];
  const letters = "ABCDEFGHIJ";
  let companyId = 0;
  for (let i = 0; i < companyCode.length; i++) {
    const idx = letters.indexOf(companyCode[i].toUpperCase());
    if (idx !== -1) companyId = companyId * 10 + idx;
  }
  return { companyId };
}

export default function StudentPassbookPage() {
  const formatDate = (date) => date.toISOString().split("T")[0];
  const today = new Date();
  const defaultFrom = new Date();
  defaultFrom.setDate(today.getDate() - 365);

  const [fromDate, setFromDate] = useState(formatDate(defaultFrom));
  const [toDate, setToDate] = useState(formatDate(today));

  const [activeTab, setActiveTab] = useState(0);

  // Retrieve student info from localStorage
  const studentUsername = localStorage.getItem("farmerUsername") || "";
  const studentData = JSON.parse(localStorage.getItem("farmerData")) || {};
  const studentName = studentData.farmer_name || "विद्यार्थ्याचे नाव";
  const collegeName = studentData.collegeName || "S.G.M. College, Karad";

  // const farmerUsername = localStorage.getItem("farmerUsername") || "";
  // const farmerData = JSON.parse(localStorage.getItem("farmerData")) || {};
  // const farmerName = farmerData.farmer_name || "उत्पादकाचे नाव";
  // const DairyName = farmerData.dairy_name || "डेअरीचे नाव";

  //   alert(farmerUsername);
  // alert(farmerData.farmerId);
  // alert(farmerData.farmer_name);
  // alert(DairyName.dairy_name);

  // alert(studentUsername);
  // alert(studentData.studentId);
  // alert(studentName);
  // alert(collegeName);

  const { companyId } = parseUsername(studentUsername);

  const handleTabChange = (event, newValue) => setActiveTab(newValue);

  // ✅ Use a different logo for the college app
  // const logoPath ="../assets/logo.png";

  // ✅ Only one tab for now
  const allTabs = [
    {
      label: "इनबॉक्स",
      component: <InboxTab fromDate={fromDate} toDate={toDate} />,
    },
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper
        elevation={2}
        sx={{
          p: 2,
          mb: 2,
          backgroundColor: "hsla(213, 58%, 46%, 1.00)",
          // backgroundImage:
          //   "linear-gradient(45deg, rgba(56, 163, 81, 0.95), rgba(13, 83, 10, 0.84))",
          border: "1px solid #0d88edff",
          borderRadius: 2,
        }}
      >
        {/* ✅ Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" color="white" fontWeight="bold">
            {/* ClassSoft - Messenger App */}
            ClassSoft
          </Typography>

          {/* Show logo only for collegeId 52 */}
          {companyId === 52 && (
            <img
              src={classsoftLogo}
              alt="ClassSoft"
              style={{ height: "50px", marginLeft: "10px" }}
            />
          )}
        </Box>

        <Typography
          variant="body1"
          fontWeight="bold"
          color="white"
          // gutterBottom="true"
        >
          Transactional Messaging App
        </Typography>
        <br>
        
        </br>
        <Typography variant="body1" fontWeight="bold" gutterBottom>
          Name: {studentName}
        </Typography>
        {/* <Typography variant="h6" gutterBottom>
          महाविद्यालय: {collegeName}
        </Typography> */}

        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <TextField
            type="date"
            label="From"
            InputLabelProps={{ shrink: true }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            size="small"
          />
          <TextField
            type="date"
            label="To"
            InputLabelProps={{ shrink: true }}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            size="small"
          />
        </Box>
      </Paper>

      {/* ✅ Only Inbox tab */}
      <AppBar
        position="static"
        sx={{ backgroundColor: "hsla(203, 82%, 49%, 1.00)" }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {allTabs.map((tab, index) => (
            <Tab key={index} label={tab.label} sx={{ color: "white" }} />
          ))}
        </Tabs>
      </AppBar>

      <Box sx={{color:"black", p: 2 }}>{allTabs[activeTab]?.component}</Box>
    </Box>
  );
}
